export default "__VITE_ASSET__f4dc597a__"